module.exports = __webpack_public_path__ + "img/Shkodran Mustafi.479b0dfc.png";